import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'react-bootstrap';

class AwardPointModal extends React.Component {
  constructor(props) {
    super(props);

    this.close = this.close.bind(this);
    this.state = {
      showModal: false,
    };
  }

  componentWillMount() {
    if (this.props.open) {
      this.setState({
        showModal: true,
      });
    }
  }

  close() {
    this.setState({ showModal: false });
  }

  render() {
    return (
      <Modal
        show={this.state.showModal}
        onHide={this.close}
        animation={true}
        bsSize="small"
        backdrop={false}
        keyboard={false}
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="form-group" style={{ textAlign: 'center' }}>
            <span><FormattedMessage id='status' defaultMessage='Status' />:</span>
          </div>
          <div className="form-group">
            <div className="row">
              <div
                className="col-md-6 col-xs-6 col-sm-6"
                style={{ textAlign: 'left' }}
              >
                <span><FormattedMessage id='awarded' defaultMessage='Awarded' />:</span>
              </div>
              <div
                className="col-md-6 col-xs-6 col-sm-6"
                style={{ textAlign: 'right' }}
              >
                <span>{this.props.data.details.awardpoints} <FormattedMessage id='points' defaultMessage='points' /></span>
              </div>
            </div>
          </div>
          <div className="form-group">
            <div className="row">
              <div
                className="col-lg-6 col-md-6 col-xs-6 col-sm-6"
                style={{ textAlign: 'left' }}
              >
                <span><FormattedMessage id='card' defaultMessage='Card' />:</span>
              </div>
              <div
                className="col-lg-6 col-md-6 col-xs-6 col-sm-6"
                style={{ textAlign: 'right' }}
              >
                <span>{this.props.data.number}</span>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default AwardPointModal;



// WEBPACK FOOTER //
// ./src/views/checkout/components/AwardPointModal.jsx